import { useState, useEffect } from "react";
import React from "react";
import { getPreliminaryOnboard, getOnboardSummary } from "../service/DirectorAPI";
import moment from "moment";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

import { jsPDF } from "jspdf";

import Pdf from "react-to-pdf";
import $ from 'jquery';

export function OnboardingDetails(props) {

    const [summaryData, setSummaryData] = useState([])
    const [preliminaryData, setpreliminaryData] = useState([])

    const ref = React.createRef();

    useEffect(() => {
        getEmployeePreliminaryGrid()
        getEmployeeSummaryGrid()

    }, [])


    const getEmployeePreliminaryGrid = async () => {

        try {
         
            let payload = {
                emp_id: props.empId
            };

            let responsedata = await getPreliminaryOnboard(payload);
            setpreliminaryData(responsedata.data.ResponseData[0]);

        } catch (e) {

        }
    };

    const getEmployeeSummaryGrid = async () => {

        try {
            let payload = {
                emp_id: props.empId
            };

            let responsedata = await getOnboardSummary(payload);
            setSummaryData(responsedata.data.ResponseData);

        } catch (e) {

        }
    };


    const handleExportExcel = async (weekdates, checkeddata) => {
        
        try {


            let exportToExcel = [['Question', 'answer']]
            let val = [], i, j;
            for (i = 0; i < preliminaryData.length; i++) {
                val = []
                val.push(preliminaryData[i].question, preliminaryData[i].answer)
                exportToExcel.push(val)
            }
            let filename = "ViewLog_Excel_" + new Date().getFullYear() + '' + new Date().getMonth() + '' + new Date().getDate() + '' + new Date().getHours() + '' + new Date().getMinutes() + '' + new Date().getSeconds();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel)
            const wb = { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] }
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data1, filename + fileExtension);
        }
        catch (error) {

        }
    }






    const premilaryBind = () => {
        
        const AccordHeading = () => {
            try {
                return (
                    <>
                        <div className="profile-onboarding-panel" id="onboarding-details">
                            <div className="row">
                                <div className="col-md-6">
                                    <button className="accordion-button float-start profile-acc-onboard-icon w-auto bg-transparent px-0" type="button" data-bs-toggle="collapse" data-bs-target="#onboarding-details-content" aria-expanded="true" aria-controls="onboarding-details">
                                    </button>
                                    <div className="ms-5 mt-1">
                                        <span className="d-block profile-onboard-title">Preliminary Evaluation</span>
                                        <span className="d-block profile-onboard-dates  regular-text">
                                            {preliminaryData.length ? moment(preliminaryData[0].created_at).format('MMM DD, YYYY') : null}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            catch (e) {

            }
        }
        try {
            return (
                <>
                    {AccordHeading()}
                    <div id="onboarding-details-content" className="accordion-collapse collapse show" aria-labelledby="onboarding-details" data-bs-parent="#onboarding-section">
                        <div className="accordion-body p-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card profile-card">
                                        <div className="card-body p-4 profile-onboarding-bg">
                                            {
                                                preliminaryData.map((prelim) => {
                                                    return (
                                                        <div>
                                                            <h5 className="card-title profile-card-title">{prelim.question}</h5>
                                                            <p className="card-text profile-card-text mb-4 regular-text">{prelim.answer}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        catch (e) {

        }
    }


    const summaryBind = () => {
        const summaryAccordHeading = (summHead, i) => {
            try {
                

                return (
                    // summHead.map((datum) => {
                    //      return (
                    <>
                        {/* <h2 className="accordion-header recruit-timeline-spacing" id={`headingTwo${i}`}>
                            <div className="row align-items-center">
                                <div className="col-md-5">
                                    <button className="recruit-accordion-button w-auto px-0 collapsed regular-text" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseTwo${i}`} aria-expanded="false" aria-controls={`collapseTwo${i}`}>
                                        {summHead[0][0]}
                                    </button>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="d-flex align-items-center recruit-border-right pe-4">
                                            <span className="recruit-summary-initial bold-text">{summHead[4][1][0]}</span>
                                            <span className="recruit-summary-username">{summHead[4][1]}</span>
                                        </div>
                                        <div className="font-14 d-flex align-items-center ps-4">
                                            {moment(summHead[3][1]).format('MMM DD, YYYY')}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="font-14 d-flex justify-content-end">
                                        <img src="Images/recruit-selected.svg" className="me-2" alt="Tick Icon" />
                                        {summHead[2][1]}
                                    </div>
                                </div>
                            </div>
                        </h2> */}

                        <div className="profile-onboarding-panel" id={`onboarding-details-gd${i}`}>
                            <div className="row">
                                <div className="col-md-6">
                                    <button className="accordion-button float-start profile-acc-onboard-icon w-auto bg-transparent px-0" type="button" data-bs-toggle="collapse" data-bs-target={`#onboarding-details-content-gd${i}`} aria-expanded="true" aria-controls={`onboarding-details-gd${i}`}>
                                    </button>
                                    <div className="ms-5 mt-1">
                                        <span className="d-block profile-onboard-title"> {summHead[0][0]}</span>
                                        <span className="d-block profile-onboard-dates regular-text">
                                            {moment(summHead[3][1]).format('MMM DD, YYYY')}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <span className="d-block profile-onboard-title">Interview by</span>
                                    <div className>
                                        <img src="/Images/logo-person-user-person-icon.jpg" alt="User Image" className="profile-onboard-user-image" />
                                        <span className="profile-onboard-user-name regular-text">{summHead[4][1]}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
                //      })
                // )
            }
            catch (e) {

            }
        }
        const AccordBody = (summBody) => {
            try {
                return (<>
                    {Object.entries(summBody[0][1]).map((el) => {
                        
                        return (
                            <>

                                <h5 className="card-title profile-card-title">{el[0]}</h5>
                                <p className="card-text profile-card-text mb-4 regular-text">{el[1]}</p>
                                {/* <div className="mb-3">
                                    <p className="recruit-summary-ques mb-1 font-14 regular-text mb-2">
                                        {el[0]}
                                    </p>
                                    <div className="custom-collapse-textarea font-14 regular-text">{el[1]}</div>
                                </div> */}
                            </>
                        )
                    })}
                    <div className="mb-3">
                        <p className="recruit-summary-ques mb-1 font-14 regular-text mb-2">
                            {summBody[1][0]}
                        </p>
                        <div className="custom-collapse-textarea font-14 regular-text"> {summBody[1][1]}</div>
                    </div>
                </>
                )
            }
            catch (e) {

            }
        }
        try {

            return (
                summaryData.map((summary, i) => {
                    return (
                        <div className="accordion-item border-0 mb-3">
                            {summaryAccordHeading(Object.entries(summary), i)}

                            <div id={`onboarding-details-content-gd${i}`} className="accordion-collapse collapse" aria-labelledby={`onboarding-details-gd${i}`} data-bs-parent="#onboarding-section-gd">
                                {/* <div id={`collapseTwo${i}`} className="accordion-collapse collapse" aria-labelledby={`headingTwo${i}`} data-bs-parent="#accordionExample"> */}
                                <div className="accordion-body p-0">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card profile-card">
                                                {AccordBody(Object.entries(summary))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    )
                })
            )
        }
        catch (e) {

        }
    }


    const openaccordian = () => {
        //document.getElementById('onboarding-details-content').classList.add('show');
        $('#onboarding-details-content').addClass('show');
    }

    const createPDF = async () => {
        const pdf = new jsPDF("portrait", "pt", "a4");
        const data = await document.querySelector("#onboarding-section");
        pdf.html(data).then(() => {
            pdf.save("shipping_label.pdf");
        });
    };

    // const printDiv = (divName, e) => {

    //     //$('.hidePrint').hide();
    //     let printContents = document.getElementById(divName).innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print();
    //     window.location.reload(false);

    // };


    return (
        <div>
            <div className="col-md-12 my-3 d-flex align-items-center ">
                <h2 className="profile-title mb-0 tt-bold">Onboarding Details</h2>
                {/* <div className="ms-auto d-flex">
                    <button className="btn hive-btn-primary small-button " onClick={() => handleExportExcel()} >Download Onboarding Details</button>
                </div> */}

                {/* <div className="ms-auto d-flex">
                    <button className="btn hive-btn-primary small-button " onClick={() => createPDF()} >Download Onboarding Details</button>
                </div> */}

                {/* <div className="ms-auto d-flex">
                    <button className="btn hive-btn-primary small-button " onClick={(e) => printDiv("onboarding-section", e)} >Download Onboarding Details</button>
                </div> */}

                <div className="ms-auto d-flex">
                    <Pdf targetRef={ref} filename={props.emp_name + "_OnboardingDetails.pdf"}>
                        {({ toPdf }) => <button className="btn hive-btn-primary small-button "
                            onClick={toPdf} >Download Onboarding Details </button>}
                    </Pdf>
                </div>

            </div>
            <div className="col-md-12">
                <div className="accordion" id="onboarding-section" ref={ref}>
                    <div className="accordion-item border-0 mb-3">
                        {premilaryBind()}
                    </div>

                    {/* <div className="accordion-item border-0 mb-3">
                        {premilaryBind()}
                    </div> */}

                    {summaryBind()}

                    {/* <div className="accordion-item border-0 mb-3"> */}
                    {/* <div className="profile-onboarding-panel" id="onboarding-details-gd">
                            <div className="row">
                                <div className="col-md-6">
                                    <button className="accordion-button float-start profile-acc-onboard-icon w-auto bg-transparent px-0" type="button" data-bs-toggle="collapse" data-bs-target="#onboarding-details-content-gd" aria-expanded="true" aria-controls="onboarding-details-gd">
                                    </button>
                                    <div className="ms-5 mt-1">
                                        <span className="d-block profile-onboard-title">Technical Interview</span>
                                        <span className="d-block profile-onboard-dates regular-text">Jun 21, 2021</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <span className="d-block profile-onboard-title">Interview by</span>
                                    <div className>
                                        <img src="/Images/logo-person-user-person-icon.jpg" alt="User Image" className="profile-onboard-user-image" />
                                        <span className="profile-onboard-user-name regular-text">Merlene</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    {/* <div id="onboarding-details-content-gd" className="accordion-collapse collapse" aria-labelledby="onboarding-details-gd" data-bs-parent="#onboarding-section-gd">
                            <div className="accordion-body p-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card profile-card">
                                            <div className="card-body p-4 profile-onboarding-bg">
                                                <h5 className="card-title profile-card-title">Attitude</h5>
                                                <p className="card-text profile-card-text mb-4 regular-text">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam. Vivamus Tincidunt Lorem Sagittis Varius Vehicula. Maecenas Luctus Congue Ero Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam.</p>
                                                <h5 className="card-title profile-card-title">Communication</h5>
                                                <p className="card-text profile-card-text mb-4 regular-text">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam. Vivamus Tincidunt Lorem Sagittis Varius Vehicula. Maecenas Luctus Congue Ero Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam.</p>
                                                <h5 className="card-title profile-card-title">Business Understanding</h5>
                                                <p className="card-text profile-card-text mb-4 regular-text">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam. Vivamus Tincidunt Lorem Sagittis Varius Vehicula. Maecenas Luctus Congue Ero Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam.</p>
                                                <h5 className="card-title profile-card-title">Technology</h5>
                                                <p className="card-text profile-card-text mb-4 regular-text">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam. Vivamus Tincidunt Lorem Sagittis Varius Vehicula. Maecenas Luctus Congue Ero Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam.</p>
                                                <h5 className="card-title profile-card-title">Final Comments</h5>
                                                <p className="card-text profile-card-text mb-1 regular-text">Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam. Vivamus Tincidunt Lorem Sagittis Varius Vehicula. Maecenas Luctus Congue Ero Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Nullam Ut Felis Quam.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    {/* </div> */}

                </div>
            </div>
        </div >


    );
}

export default OnboardingDetails;